// extracted by mini-css-extract-plugin
export default {"root":"table_root__kp+mh","empty":"table_empty__yEIbH","input":"table_input__t48ji","pagination":"table_pagination__O7S7D"};